module.exports = {"term_agreement_by_ll_owner":"Shuruudaha Heshiiska ee Milkiilaha/Maareeyaha Guriga"};